import moment from "moment";
import { CustomCellRendererProps } from "ag-grid-react";
import { Box, Typography, useTheme } from "@material-ui/core";
import locale, { dateFormat } from "@bonliva-crm/locale";
import { ConsultantRowData } from "../../../utils/consultant-row-data";

type Props = CustomCellRendererProps<ConsultantRowData> & {
  country: string;
  itemName: string;
  expirationDateLabel?: string;
};

export function CriminalCheckRenderer(props: Props) {
  const theme = useTheme();

  const qc = props.data?.qualityChecks?.find(
    (x) => x.country === props.country && x.itemName === props.itemName
  );

  if (!qc) {
    return null;
  }

  const setOn = qc.setDate ? moment(qc.setDate).format(dateFormat) : "";
  const expiresOn = qc.expirationDate ? moment(qc.expirationDate).format(dateFormat) : "";

  let bgColor = undefined;

  if (qc.status === "Approved") {
    bgColor = theme.palette.success.light;
  }

  if (qc.expirationDate && new Date(qc.expirationDate) < new Date()) {
    bgColor = theme.palette.error.light;
  }

  const status = locale.qualityStatuses[qc.status] || qc.status;
  const criminalRecordType = qc.params?.criminalRecordType
    ? locale.criminalRecordType[qc.params.criminalRecordType]
    : null;
  const statusWithCriminalRecordType = [status, criminalRecordType]
    .filter(Boolean)
    .join(" - ");

  return (
    <Box style={{ backgroundColor: bgColor }} height="100%" width="100%" p={0.5}>
      {status ? (
        <Typography variant="body2" display="block">
          {statusWithCriminalRecordType}
        </Typography>
      ) : null}

      {setOn && (
        <Typography variant="caption" display="block">
          {locale.Date}: {setOn}
        </Typography>
      )}

      {expiresOn && (
        <Typography variant="caption" display="block">
          {props.expirationDateLabel || locale.Expires}: {expiresOn}
        </Typography>
      )}
    </Box>
  );
}
